import { Component } from 'react';
import HoldingLayout from './HoldingLayout';

const TEAM_MEMBERS = [
  { name: 'Team Member', role: 'CEO & Co-Founder', placeholder: true },
  { name: 'Team Member', role: 'CTO & Co-Founder', placeholder: true },
  { name: 'Team Member', role: 'Head of Product', placeholder: true },
  { name: 'Team Member', role: 'Lead Engineer', placeholder: true },
  { name: 'Team Member', role: 'Marketing Lead', placeholder: true },
  { name: 'Team Member', role: 'Operations', placeholder: true },
];

class Team extends Component {
  render() {
    return (
      <HoldingLayout>
        {/* Hero */}
        <section className="h-page-hero h-page-hero-sm">
          <div className="h-hero-bg-pattern" aria-hidden="true" />
          <div className="h-section-inner">
            <div className="h-page-hero-content">
              <span className="h-section-tag">Our Team</span>
              <h1 className="h-page-hero-title">The people behind Rakeen</h1>
              <p className="h-page-hero-desc">
                A small, focused team in Khobar building software that Saudi businesses rely on every day.
              </p>
            </div>
          </div>
        </section>

        {/* Team Grid */}
        <section className="h-page-team">
          <div className="h-section-inner">
            <div className="h-team-grid">
              {TEAM_MEMBERS.map((member, i) => (
                <div key={i} className="h-team-card">
                  <div className="h-team-avatar">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.3">
                      <circle cx="24" cy="18" r="8" />
                      <path d="M8 42c0-8 7-14 16-14s16 6 16 14" />
                    </svg>
                  </div>
                  <h3 className="h-team-name">{member.name}</h3>
                  <p className="h-team-role">{member.role}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Company Values */}
        <section className="h-page-values">
          <div className="h-section-inner">
            <div className="h-section-header">
              <span className="h-section-tag">What Drives Us</span>
              <h2 className="h-section-title">Our principles</h2>
            </div>
            <div className="h-values-grid">
              <div className="h-value-card">
                <h3 className="h-value-title">Focus over breadth</h3>
                <p className="h-value-desc">
                  Each product solves one problem exceptionally well. We don't dilute our efforts by trying to do everything.
                </p>
              </div>
              <div className="h-value-card">
                <h3 className="h-value-title">Built for Saudi</h3>
                <p className="h-value-desc">
                  We build for the market we know. Arabic-first interfaces, local business workflows, and compliance that makes sense here.
                </p>
              </div>
              <div className="h-value-card">
                <h3 className="h-value-title">Ship and iterate</h3>
                <p className="h-value-desc">
                  We'd rather launch and learn than plan forever. Real feedback from real users drives our roadmap.
                </p>
              </div>
            </div>
          </div>
        </section>
      </HoldingLayout>
    );
  }
}

export default Team;
